













import { BuildQuestion } from '@/utils/add-question/add-question-util';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class BuildKeyword extends Vue {
  @Prop()
  buildQuestion!: BuildQuestion;
}
